import * as R from 'ramda'
import { useSelector } from 'react-redux'
import { determineAccess } from 'app/auth/accessControlService'

export const usePermissionInfo = () =>
  useSelector(R.path(['auth', 'user', 'permissionInfo']))

export const useAccessControl = (accesses, context) => {
  const permissionInfo = usePermissionInfo()
  return determineAccess(permissionInfo, accesses)
}
